module.exports = __webpack_public_path__ + "static/media/edge_logo.09310bd6.svg";